module.exports = __webpack_public_path__ + "static/media/server.81ef6eae.png";